import React, { useMemo } from "react";
import { Table, Tag, Button } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import moment from "moment-jalaali";
import columns from "@staticData/admin/adminServicesTableColumns";
import { SERVICE_TYPES, SERVICE_STATUSES } from "@staticData/services";

function AdminServicesTable({
  services,
  totalCount,
  currentPage,
  pageSize,
  loading,
  onPageChange,
  onSort,
  onOpenDetails,
}) {
  const dataSource = useMemo(() => {
    if (!services || !Array.isArray(services)) return [];

    return services.map((item) => {
      const {
        id,
        user,
        serviceName,
        serviceType,
        status,
        amount,
        createdAt,
        startAt,
        endAt,
        packageName,
      } = item;

      const statusConfig = SERVICE_STATUSES[status] || {
        label: status,
        color: "default",
      };
      const typeLabel = SERVICE_TYPES[serviceType] || serviceType;
      const isMeetingOrConsultation =
        serviceType === "MEETING_ROOM" || serviceType === "CONSULTATION";

      const formatDate = (date, withTime = false) => {
        if (!date) return "-";
        return withTime
          ? moment(date).format("jYYYY/jMM/jDD | HH:mm")
          : moment(date).format("jYYYY/jMM/jDD");
      };

      return {
        key: id,
        raw: item,
        userName: user?.name || user?.mobile || "-",
        userMobile: user?.mobile || "-",
        serviceName: (
          <div>
            <strong>{serviceName}</strong>
            {packageName && (
              <div style={{ fontSize: 12, color: "#888" }}>{packageName}</div>
            )}
          </div>
        ),
        serviceType: <Tag color="cyan">{typeLabel}</Tag>,
        status: <Tag color={statusConfig.color}>{statusConfig.label}</Tag>,
        startAt: formatDate(startAt, isMeetingOrConsultation),
        endAt: formatDate(endAt, isMeetingOrConsultation),
        amount: amount ? `${amount.toLocaleString()}` : "0",
        createdAt: formatDate(createdAt),
        details: (
          <Button
            type="text"
            icon={<EyeOutlined />}
            onClick={() => onOpenDetails(item)}
            title="مشاهده جزییات"
          />
        ),
      };
    });
  }, [services, onOpenDetails]);

  const handleTableChange = (pagination, filters, sorter, extra) => {
    if (extra.action === "sort") {
      onSort(sorter);
    }
    if (extra.action === "paginate") {
      onPageChange(pagination.current);
    }
  };

  return (
    <Table
      columns={columns}
      dataSource={dataSource}
      loading={loading}
      pagination={{
        total: totalCount,
        current: currentPage,
        pageSize: pageSize || 10,
        showSizeChanger: false,
      }}
      onChange={handleTableChange}
      scroll={{ x: 1100 }}
      locale={{
        emptyText: "هیچ سرویسی یافت نشد",
      }}
    />
  );
}

export default AdminServicesTable;
